import { Provider } from 'mobx-react';
import * as React from 'react';
import { TreeLink } from './TreeLink';
import { TreeLinkStore } from './store/TreeLinkStore';
import { IInstance } from '../../interfaces/IInstance';
import { ITreeLinkNode } from '../../interfaces/ITreeLinkNode';
import { ITargetingApplications } from '../../interfaces/ITargetingApplications';
import { IFontSlots } from '../../interfaces/IFontSlots';

export interface IIATreeLinkProps {
  tenant: string;
  environment: "Development" | "Test" | "Production";
  token: string;
  treeLink: ITreeLinkNode;
  instance: IInstance;
  isMobile: boolean;
  highlightColor: string;
  editHighlightColor: string;
  backgroundColor: string;
  lineColor: string;
  textColor: string;
  iconColor: string;
  borderRadius?: string;
  defaultIcon: string;
  showLine: boolean;
  isDragging: boolean;
  dropShadow: boolean;
  showIconOnItems: boolean;
  hasDarkBackground: boolean;
  inEditMode: boolean;
  showDropZoneForId: string;
  applicationSettings?: ITargetingApplications;
  expandAsDefault?: boolean;
  amountOfFirstLevelItemsToShow?: number;
  styles?: React.CSSProperties;
  disableDrop?: boolean;
  returnPageUrl?: boolean;
  openAllLinksExternally?: boolean;
  fontSlots?: IFontSlots;
  removeTree?: () => void;
  rerender: () => void;
  save: (treeLink: ITreeLinkNode) => void;
  onClick: (node: ITreeLinkNode) => void;
  onDragEnter: (node: ITreeLinkNode) => void;
  onDrop: (node: ITreeLinkNode) => void;
  onDrag: (node: ITreeLinkNode) => void;
  showPage?: (page: string) => void;
}

export class IATreeLink extends React.Component<IIATreeLinkProps> {

  private treeLinkStore: TreeLinkStore;

  constructor(props: IIATreeLinkProps) {
    super(props);
    this.treeLinkStore = new TreeLinkStore();
    this.updateProperties(props);
  }

  componentWillReceiveProps(props: IIATreeLinkProps): void {
    this.updateProperties(props);
  }

  private updateProperties(props: IIATreeLinkProps): void {
    this.treeLinkStore.setInstance(props.instance);
    this.treeLinkStore.setEnvironment(props.environment);
    this.treeLinkStore.setTenant(props.tenant);
    this.treeLinkStore.setToken(props.token);
    this.treeLinkStore.setHighlightColor(props.highlightColor);
    this.treeLinkStore.setTreeLink(props.treeLink);
    this.treeLinkStore.setBackgroundColor(props.backgroundColor);
    this.treeLinkStore.setLineColor(props.lineColor);
    this.treeLinkStore.setTextColor(props.textColor);
    this.treeLinkStore.setIconColor(props.iconColor);
    this.treeLinkStore.setDefaultIcon(props.defaultIcon);
    this.treeLinkStore.setShowLine(props.showLine);
    this.treeLinkStore.setDropShadow(props.dropShadow);
    this.treeLinkStore.setBorderRadius(props.borderRadius);
    this.treeLinkStore.setApplicationSettings(props.applicationSettings);
    this.treeLinkStore.setShowIconOnItems(props.showIconOnItems);
    this.treeLinkStore.setIsMobile(props.isMobile);
    this.treeLinkStore.setHasDarkBackground(props.hasDarkBackground);
    this.treeLinkStore.setAmountOfFirstLevelItemsToShow(props.amountOfFirstLevelItemsToShow);
    this.treeLinkStore.setStyles(props.styles);
    this.treeLinkStore.setInEditMode(props.inEditMode);
    this.treeLinkStore.setExpandAsDefault(props.expandAsDefault);
    this.treeLinkStore.setIsDragging(props.isDragging);
    this.treeLinkStore.setEditHighlightColor(props.editHighlightColor);
    this.treeLinkStore.setReturnPageUrl(props.returnPageUrl);
    this.treeLinkStore.setOpenAllLinksExternally(props.openAllLinksExternally);
    this.treeLinkStore.setFontSlots(props.fontSlots);
  }

  public render(): JSX.Element {
    return (
      <Provider treeLinkStore={this.treeLinkStore}>
        <TreeLink
          removeTree={() => this.props.removeTree()}
          rerender={() => this.props.rerender()}
          save={(treeLink: ITreeLinkNode) => this.props.save(treeLink)}
          onClick={(node: ITreeLinkNode) => this.props.onClick(node)} 
          showDropZoneForId={this.props.showDropZoneForId}
          onDragEnter={(node: ITreeLinkNode) => this.props.onDragEnter(node)}
          onDrag={(node: ITreeLinkNode) => this.props.onDrag(node)}
          onDrop={(node: ITreeLinkNode) => this.props.onDrop(node)}
          showPage={(page: string) => this.props.showPage(page)}
        />
      </Provider>
    )
  }
}
